import { List } from 'immutable';

import minuteDuration from './minuteDuration';
import expandedTimeplanUnits from '../../../entities/TimeplanUnit/expandedTimeplanUnits';
import { WorkTypeRecord } from '../../../entities/records';

const getMinutes = (timeplanUnits, workTypeId) => {
  if (!timeplanUnits) {
    return 0;
  }

  return timeplanUnits
    .filter(timeplanUnit => timeplanUnit.workType === workTypeId)
    .reduce((result, value) => result + minuteDuration(value), 0);
};

const setAbsentReasonsAsWorkType = (timeplanUnits, absentReasons) => {
  if (absentReasons.length === 0) {
    return timeplanUnits;
  }

  return timeplanUnits.map(({ absentReason, workType, ...o }) => ({
    ...o,
    workType: absentReason || workType,
    absentReason,
  }));
};

export default function summarizeTimeplanUnits(
  workTypes,
  timeplanUnits,
  compareTimeplanUnits,
  absentReasons = new List(),
) {
  const absentReasonsAsWorkTypes = absentReasons
    .map(({ name, type }) => new WorkTypeRecord({ id: type, type, name }));
  const innerTPUs = setAbsentReasonsAsWorkType(timeplanUnits, absentReasons);
  const innerCompareTPUs = setAbsentReasonsAsWorkType(compareTimeplanUnits, absentReasons);
  return workTypes
    .concat(absentReasonsAsWorkTypes)
    .map((workType) => {
      const minutes = getMinutes(
        expandedTimeplanUnits(innerTPUs),
        workType.id,
      );
      const compareMinutes = getMinutes(
        expandedTimeplanUnits(innerCompareTPUs),
        workType.id,
      );

      const diffMinutes = innerCompareTPUs && innerCompareTPUs.length > 0 ?
        (minutes - compareMinutes) : 0;

      return {
        id: workType.id,
        name: workType.name,
        minutes,
        diffMinutes,
      };
    })
    .filter(({ minutes, diffMinutes }) => minutes > 0 || diffMinutes !== 0);
}
